import { useAuthInit } from "@/services/auth";

import { Router } from "./router.component";

export const RouterWrapper = () => {
  const { isUserSessionLoaded } = useAuthInit();

  if (!isUserSessionLoaded) return null;

  return <Router />;
};
